export default "__VITE_ASSET__DSAkmsEt__"